import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {DEFAULT_PAGE_SIZE} from '../../shared';
import {SelectedItem} from '../../order/models/order';
import {CompaniesFilter, CompaniesList} from '../models/companies-list';
import {
  ChangeCompaniesPageSizeAction,
  companiesListActionTypes, LoadCompaniesSuccessAction, OrderCompaniesByAction,
  PageCompaniesToAction,
  QuickSearchCompaniesAction,
  SearchCompaniesAction,
  ToggleSearchCompaniesAction
} from '../actions/companies-list';

export interface CompaniesState {
  array: CompaniesList[];
  showFilter: boolean;
  quickSearch: string;
  filter: CompaniesFilter;
  page: number;
  pageSize: number;
  orderBy: string;
  count: number;
  selectedCompany: SelectedItem[];
}

const initialState: CompaniesState = {
  array: undefined,
  showFilter: false,
  quickSearch: undefined,
  filter: undefined,
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  orderBy: 'created descending',
  count: 0,
  selectedCompany: [],
};

export function CompaniesListReducer(state: CompaniesState = initialState, action: Action): CompaniesState {
  switch (action.type) {
    case companiesListActionTypes.TOGGLE_SEARCH:
      return handleToggleSearchAction(state, action);
    case companiesListActionTypes.QUICK_SEARCH:
      return handleQuickSearchAction(state, action);
    case companiesListActionTypes.SEARCH:
      return handleSearchAction(state, action);
    case companiesListActionTypes.PAGE_TO:
      return handlePageToAction(state, action);
    case companiesListActionTypes.CHANGE_PAGE_SIZE:
      return handleChangePageSizeAction(state, action);
    case companiesListActionTypes.ORDER_BY:
      return handleOrderByAction(state, action);
    case companiesListActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case companiesListActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case companiesListActionTypes.CLEAR:
      return handleLoadClearActions();
    default:
      return state;
  }
}

function handleToggleSearchAction(state: CompaniesState, action: ToggleSearchCompaniesAction): CompaniesState {
  const newState: CompaniesState = {
    ... state,
    showFilter: action.payload,
    selectedCompany: []
  };
  return newState;
}

function handleQuickSearchAction(state: CompaniesState, action: QuickSearchCompaniesAction): CompaniesState {
  const newState: CompaniesState = {
    ... state,
    quickSearch: action.payload,
    page: 1,
    selectedCompany: []
  };
  return newState;
}

function handleSearchAction(state: CompaniesState, action: SearchCompaniesAction): CompaniesState {
  const newState: CompaniesState = {
    ... state,
    filter: action.payload,
    page: 1,
    selectedCompany: []
  };
  return newState;
}

function handlePageToAction(state: CompaniesState, action: PageCompaniesToAction): CompaniesState {
  const newState: CompaniesState = {
    ... state,
    page: action.payload,
    selectedCompany: []
  };
  return newState;
}

function handleLoadSuccessAction(state: CompaniesState, action: LoadCompaniesSuccessAction): CompaniesState {
  const newState: CompaniesState = {
    ... state,
    array: action.payload.array,
    count: action.payload.count,
    selectedCompany: []
  };
  return newState;
}


function handleChangePageSizeAction(state: CompaniesState, action: ChangeCompaniesPageSizeAction): CompaniesState {
  const newState: CompaniesState = {
    ... state,
    page: 1,
    pageSize: action.payload,
    selectedCompany: []
  };
  return newState;
}
function handleOrderByAction(state: CompaniesState, action: OrderCompaniesByAction): CompaniesState {
  const newState: CompaniesState = {
    ... state,
    orderBy: action.payload,
    selectedCompany: []
  };
  return newState;
}

function handleLoadClearActions(): CompaniesState {
  const newState: CompaniesState = {
    array: undefined,
    showFilter: false,
    quickSearch: undefined,
    filter: undefined,
    page: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    orderBy: 'created descending',
    count: 0,
    selectedCompany: [],
  };
  return newState;
}

function handleLoadErrorActions(state: CompaniesState): CompaniesState {
  return state;
}


export const companiesListSelectors = {
  showFilter: (state: CompaniesState) => _.get(state, 'showFilter', false),
  quickSearch: (state: CompaniesState) => _.get(state, 'quickSearch'),
  filter: (state: CompaniesState) => _.get(state, 'filter'),
  page: (state: CompaniesState) => _.get(state, 'page', 1),
  pageSize: (state: CompaniesState) => _.get(state, 'pageSize', DEFAULT_PAGE_SIZE),
  orderBy: (state: CompaniesState) => _.get(state, 'orderBy'),
  array: (state: CompaniesState) => _.get(state, 'array', []),
  count: (state: CompaniesState) => _.get(state, 'count', 0),
  selectedCompany: (state: CompaniesState) => _.get(state, 'selectedCompany', [])
};
